var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReminder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7321 18.0006C13.3862 18.5981 12.7401 19 12 19C11.26 19 10.6138 18.5981 10.2679 18.0006H13.7321ZM12 5C12.5523 5 13 5.44772 13 6L13.0001 6.10508C15.0465 6.54167 16.6206 8.29115 16.765 10.4579L16.9909 13.8463L18.4288 16.2428C18.6287 16.576 18.3887 17 18 17H6.00004C5.61139 17 5.37134 16.576 5.57129 16.2428L7.00918 13.8463L7.23507 10.4579C7.3795 8.29138 8.95327 6.54203 10.9993 6.10522L11 6C11 5.44772 11.4478 5 12 5ZM12 7C10.0124 7 8.36508 8.54111 8.23286 10.5244L7.99893 14.0333C7.99365 14.1124 7.96961 14.1892 7.92879 14.2572L6.88313 16H17.1169L16.0713 14.2572C16.0305 14.1892 16.0064 14.1124 16.0011 14.0333L15.7672 10.5244C15.635 8.54111 13.9877 7 12 7ZM19.5 2C19.7762 2 20 2.22386 20 2.5L19.9993 4H21.5C21.7762 4 22 4.22386 22 4.5C22 4.77614 21.7762 5 21.5 5H19.9993L20 6.5C20 6.77614 19.7762 7 19.5 7C19.2239 7 19 6.77614 19 6.5L18.9993 5H17.5C17.2239 5 17 4.77614 17 4.5C17 4.22386 17.2239 4 17.5 4H18.9993L19 2.5C19 2.22386 19.2239 2 19.5 2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.00c41ac611fde4e81f084cef30cdc8ea.svg";
export { ForwardRef as ReactComponent };